/* eslint-disable */
import { rootApi } from '../rootApi';

export const dealerAddressBrandAddrReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        // 📌 Liste
        getAllDealerAddressBrandAddrReport: builder.query({
            query: ({ dealerAddressBrandId, pageNumber = 1, pageSize = 10, languageId }) => ({
                url: 'v1/dealeraddressbrandaddrreport/getlist',
                method: 'POST',
                body: { dealerAddressBrandId, pageNumber, pageSize, languageId }
            }),
            transformResponse: (response) => {
                return {
                    items: response?.data?.items || [],
                    count: response?.data?.totalCount || 0
                };
            },
            providesTags: ['DealerAddressBrandAddrReport']
        }),

        // 📌 Tek kayıt
        getByIdDealerAddressBrandAddrReport: builder.query({
            query: (id) => ({
                url: 'v1/dealeraddressbrandaddrreport/getbyid',
                method: 'POST',
                body: { id }
            }),
            transformResponse: (response) => {
                if (response?.data) {
                    return response.data;
                }
                return {};
            },
            providesTags: (result, error, id) => [{ type: 'DealerAddressBrandAddrReport', id }]
        }),

        // 📌 Kaydet
        createDealerAddressBrandAddrReport: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeraddressbrandaddrreport/save',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandAddrReport', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        // 📌 Güncelle
        updateDealerAddressBrandAddrReport: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeraddressbrandaddrreport/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandAddrReport', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        // 📌 Sil
        deleteDealerAddressBrandAddrReport: builder.mutation({
            // Hem sayısal id hem { id, dealerAddressBrandId } kabul edilir (id request'e gider,
            // dealerAddressBrandId yalnızca hedefli cache invalidation için kullanılır).
            query: (arg) => {
                const id = arg && typeof arg === 'object' ? arg.id : arg;
                return {
                    url: 'v1/dealeraddressbrandaddrreport/delete',
                    method: 'DELETE',
                    params: { id }
                };
            },
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandAddrReport', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        // ✅ INTERSERVICE DROPDOWN
        getInterserviceDropdownList: builder.query({
            query: (selectType) => ({
                url: 'v1/dealeraddressbrandaddrreport/getinterservicedropdownlist',
                method: 'GET',
                params: {
                    selectType: selectType
                }
            })
        }),

        // ✅ INTERSERVICE ADDRESS DROPDOWN (parametre DealerId)
        getInterserviceAddrDropdownList: builder.query({
            query: (selectType) => ({
                url: 'v1/dealeraddressbrandaddrreport/getinterserviceaddrdropdownlist',
                method: 'GET',
                params: {
                    selectType: selectType
                }
            })
        }),

        // ✅ DEALER ADDRESS DROPDOWN (parametre DealerId)
        getDealerAddrDropdownList: builder.query({
            query: (dealerId) => ({
                url: 'v1/dealeraddressbrandaddrreport/getdealeraddrdropdownlist',
                method: 'GET'
            })
        })
    })
});

export const {
    useGetAllDealerAddressBrandAddrReportQuery,
    useGetByIdDealerAddressBrandAddrReportQuery,
    useCreateDealerAddressBrandAddrReportMutation,
    useUpdateDealerAddressBrandAddrReportMutation,
    useDeleteDealerAddressBrandAddrReportMutation,
    useGetInterserviceDropdownListQuery,
    useGetInterserviceAddrDropdownListQuery,
    useGetDealerAddrDropdownListQuery
} = dealerAddressBrandAddrReportApi;
